import { CREDIT_COSTS } from "./accountRules";

// How credits read to users: the account menu's usage line and the cost beside each AI
// button. credits is the Subscribe servlet's status "credits": {left, monthly, allowance,
// topup, enddate} or null. Costs are CREDIT_COSTS (CreditData.COST_* on the server).

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
// "27 Nov" from 'yyyy-mm-dd'
export const shortDay = (s) => { const [, m, d] = s.split('-').map(Number); return d + ' ' + MONTHS[m - 1]; };

export const countCredits = (n) => n + ' credit' + (n === 1 ? '' : 's');

// "42 credits left until 27 Nov"
export const creditsLine = (credits) => {
    if (!credits) return null;
    return countCredits(credits.left) + ' left until ' + shortDay(credits.enddate);
};

// What a run costs, shown beside its button (not in it): cost its credits, left the user's
// credits left; included: a single report pays for it
export const costNote = ({cost, left, included = false}) => {
    if (included) return 'Included in your report';
    if (left == null || cost == null) return null;
    if (left < cost) return 'Needs ' + countCredits(cost) + ', you have ' + left + ' left';
    return 'Uses ' + countCredits(cost) + ' of your ' + left + ' left';
};

// What a link check costs: rent for a home to rent
export const listingCost = (rent) => rent ? CREDIT_COSTS.rentListing : CREDIT_COSTS.listing;

// The area guide's button for the user (GetAIOverview's access answer: state, cost, writecost,
// left): {label, note, can, blocked}, note being its cost, shown beside it. again: writing it
// again (the out of date warning, Write it again), which costs writecost; blocked is none (not
// enough credits), plan, login or null.
export const areaButton = (access, again = false) => {
    const write = again ? 'Write the area guide again' : 'Write the area guide';
    if (!access || access.error) return {label:write, note:null, can:true, blocked:null};
    const saved = !again && access.state === 'saved';
    const action = saved ? 'Open the area guide' : write;
    const cost = again ? access.writecost : access.cost;
    const theirs = !again && (access.state === 'owned' || access.state === 'owned_stale');
    if (cost === 'free') return {label:theirs ? 'Area guide ready, free to open' : action, note:theirs ? null : 'Free', can:true, blocked:null};
    if (cost === 'included') return {label:action, note:costNote({included:true}), can:true, blocked:null};
    if (cost === 'credit') return {label:action, note:costNote({cost:CREDIT_COSTS.area, left:access.left}), can:true, blocked:null};
    return {label:action, note:null, can:false, blocked:cost === 'none' ? 'none' : cost === 'login' ? 'login' : 'plan'};
};

// The offer guide's button: single is the listing's single report ({status, type, offerdone}),
// plan the Subscribe servlet's status
export const offerButton = (plan, single, again = false) => {
    const action = again ? 'Write the offer guide again' : 'Write the offer guide';
    if (single && single.status === 'making' && single.unlocked !== false && single.type === 'buy' && !single.offerdone) {
        return {label:action, note:costNote({included:true}), can:true, blocked:null};
    }
    if (plan === undefined) return {label:action, note:null, can:true, blocked:null};
    if (!plan || !plan.credits) return {label:action, note:null, can:false, blocked:plan && plan.signedin === false ? 'login' : 'plan'};
    const left = plan.credits.left;
    const can = left >= CREDIT_COSTS.offer;
    return {label:action, note:can ? costNote({cost:CREDIT_COSTS.offer, left}) : null, can, blocked:can ? null : 'none'};
};
